import { useQuery } from '@tanstack/react-query';
import { getBagelObjects } from '../api/settings';

export const useBagelObjects = (auth0: any) => {
  return useQuery({
    queryKey: ['bagelObjects'],
    queryFn: () => getBagelObjects(auth0),
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes
  });
}; 